<div class="w-full accordian-wrapper">
  <div *ngFor="let accordion of accordionModule;let index=index; trackBy: trackByAccordion" class="w-full">
    <div
      class="w-full layout-section-wrapper w-full flex items-center">
      <div class="icon-wrapper w-[100%] flex justify-end items-end">
        <app-icon (click)="moveContentElementUp(index)" [class.cursor-pointer]="index>0"
                  [svgIcon]="index>0?'up-arrow':'up-arrow-disabled'"
                  class="up-arrow-disabled-icon"></app-icon>
        <app-icon (click)="moveContentElementDown(index)"
                  [class.cursor-pointer]="index+1 < accordionModule.length"
                  [svgIcon]="index+1 < accordionModule.length ? 'down-arrow' :'down-arrow-disabled'"
                  class="down-arrow-disabled-icon"></app-icon>
        <app-icon (click)="deleteContentElement(index)" class="cursor-pointer delete-bold-icon"
                  svgIcon="delete-bold"></app-icon>
      </div>
    </div>
    <div class="w-full">
      <app-add-accordion-form (accordionDataEmitter)="onAccordionDataChange($event,index)"
      [id]="'accordion'+index"
                              [accordionData]="accordion"></app-add-accordion-form>
    </div>
  </div>

  <!--  add new accordion module-->
  <div
    class="w-full flex justify-center add-accordion-wrapper">
    <div class="add-icon">
      <app-icon (click)="addNewAccordion()" class="add-accordion" svgIcon="add-bold"></app-icon>
    </div>
    <div (click)="addNewAccordion()" class="add-accordion-section">
      Add Accordion Module
    </div>

  </div>
</div>
